import { useEffect, useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { FileIcon } from '@trinity/chat-components/components/icons/File';
import { cx } from '@trinity/chat-components/utils';
import styles from './style/FileDownloadActivity.module.css';

type Props = {
  extension?: string;
  filename?: string;
  index: number;
  onCancel?: () => void;
  onRemove?: () => void;
  status: 'init' | 'transferring' | 'error' | 'complete';
  title?: string;
};

export const FileDownloadActivityItem = ({ onRemove, ...props }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;

    if (node !== null) {
      node.addEventListener('animationend', onRemove);
    }

    return () => {
      node?.removeEventListener('animationend', onRemove);
    };
  }, [
    onRemove,
  ]);

  const error = props.status === 'error';
  const complete = props.status === 'complete';
  const showCloseButton = error || complete;

  let titleText = props.title;
  if (error) titleText = `There was an error`;
  else if (complete) titleText = `Upload complete`;

  return (
    <div
      className={cx(styles.root, {
        [styles.transferring]: props.status === 'transferring',
      })}
      ref={ref}
      style={{ bottom: (props.index * 110) + ((props.index + 1) * 10) }}>
      <div
        className={styles.wrap}>
        <div className={styles.main}>
          {showCloseButton &&
            <button
              className={styles.close}
              onClick={onRemove}>
              <CloseIcon />
            </button>}
          <div className={styles.title}>
            {titleText}
          </div>
          <div className={styles.content}>
            <div className={styles.icon}>
              <FileIcon
                extension={props.extension}
                size={30} />
            </div>
            <div className={styles.info}>
              <div
                className={styles.name}
                title={props.filename}>
                {props.filename ?? 'Untitled'}
              </div>
              <div className={styles.stats}>
                <div className={styles.bar}>
                  {!error && !complete && <span className={styles.one} />}
                  {!error && !complete && <span className={styles.two} />}
                </div>
                {!error && !complete &&
                  <button
                    className={styles.cancel}
                    onClick={props.onCancel}>
                    Cancel
                  </button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FileDownloadActivityItem.displayName = 'FileDownloadActivity.Item';